module.exports = __webpack_public_path__ + "assets/b20cd9acf45420fcacfd923754185663.js";